import React from 'react';
import ChatHeader from './ChatHeader';
import ChatBody from './ChatBody';
import ChatFooter from './ChatFooter';

const ChatWindow = ({
  config,
  theme,
  loading,
  messages,
  user,
  typing,
  error,
  draft,
  sending,
  onToggleTheme,
  onClear,
  onMinimize,
  onClose,
  onDraftChange,
  onSend,
  onSelectQuick,
  onFeedback,
  onRetry,
  onDismissError
}) => {
  const showGreetingChips = messages.length === 0 && !typing;

  return (
    <section
      className="edugenie-window"
      role="dialog"
      aria-modal="false"
      aria-label="EduGenie chat window"
    >
      <ChatHeader
        botName={config?.bot_name}
        tagline={config?.bot_tagline}
        panelType={config?.panel_type}
        theme={theme}
        onToggleTheme={onToggleTheme}
        onClear={onClear}
        onMinimize={onMinimize}
        onClose={onClose}
      />
      <ChatBody
        loading={loading}
        greetingText={config?.greeting_text}
        messages={messages}
        user={user}
        typing={typing}
        error={error}
        showGreetingChips={showGreetingChips}
        quickActions={config?.quick_actions || []}
        suggestedQuestions={config?.suggested_questions || []}
        sending={sending}
        onSelectQuick={onSelectQuick}
        onFeedback={onFeedback}
        onRetry={onRetry}
        onDismissError={onDismissError}
      />
      <ChatFooter
        value={draft}
        onChange={onDraftChange}
        onSend={onSend}
        disabled={sending || loading || typing}
      />
    </section>
  );
};

export default ChatWindow;
